import { all, fork, take, put, select } from 'redux-saga/effects';
import { format } from 'date-fns';
import { SEARCH_FORMAT_DATE } from '@ts/utils/constants';
import { attractionsUrl } from '@ts/utils/urls';
// import Analytics from '@ts/utils/analytics';

import actions from '../actions';
import selectors from '../selectors';

export function* watchSubmit() {
    while (true) {
        yield take(actions.search.ActionTypes.SUBMIT);

        const destination = yield select(selectors.search.makeSelectDestination());
        const category = yield select(selectors.search.makeSelectDestinationCategory());
        const dateFrom = yield select(selectors.search.makeSelectDateFrom());
        const dateTo = yield select(selectors.search.makeSelectDateTo());
        const dateFromQs = dateFrom ? format(dateFrom, SEARCH_FORMAT_DATE) : undefined;
        const dateToQs = dateTo ? format(dateTo, SEARCH_FORMAT_DATE) : undefined;
        const dateQsIsValid = Boolean(dateFromQs && dateToQs);
        const dateQs = dateQsIsValid ? { from: dateFromQs, to: dateToQs } : {};

        const reqUrl = attractionsUrl({
            ...dateQs,
            destination: destination ? destination.slug : undefined,
            category: category ? category.slug : undefined,
        });

        yield put(actions.app.pushLocation(reqUrl));

        // Analytics.wrapAvoidError(() =>
        //     Analytics.siteSearch(
        //         Analytics.helpers.makeSiteSearch({
        //             from: dateFrom,
        //             to: dateTo,
        //             destination,
        //             category,
        //             reqUrl,
        //         })
        //     )
        // );
    }
}

export default function* searchSaga() {
    yield all([fork(watchSubmit)]);
}
